<script>
  export default {
    name: 'PhoneFrame',
    mounted() {
      this.$nextTick(function() {
        window.addEventListener('resize', this.resized);
        this.resized();
      });
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resized);
    },
    methods: {
      resized() {
        if (!this.$refs.frame) {
          return;
        }

        const scale = Math.min(
          260 / this.$refs.frame.offsetWidth,
          (window.innerHeight - 200) / this.$refs.frame.offsetHeight,
        );

        this.$refs.frame.style.transform = `scale(${scale})`;
        this.$emit('scale', {
          width: this.$refs.frame.offsetWidth * scale,
          height: this.$refs.frame.offsetHeight * scale,
        });
      },
    },
  };
</script>

<template>
  <div ref="frame" class="frame">
    <div class="frame__content">
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
.frame {
  @apply w-full overflow-hidden relative bg-white border border-50 p-3;
  width: 260px;
  height: 517px;
  border-radius: 2.6rem;
  transform-origin: top center;
}

.frame__content {
  @apply w-full h-full border border-50 overflow-hidden;
  border-radius: 2.2rem;
}

.frame__content > div {
  @apply w-full h-full overflow-x-hidden overflow-y-scroll overflow-x-hidden;
  transform: scale(0.7);
  transform-origin: 0 0;
  box-sizing: border-box;
  width: 142.75%; /* (100 / 0.6) * 10 */
  height: 142.75%;
}
</style>
